import * as React from 'react'

import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Flex } from '@chakra-ui/react'

import {
  SideMenuLayoutBreadcrumb,
  SideMenuLayoutContentLayout,
  toaster,
} from '@enechain/ecloud-designsystem'

import { useLoginUser } from '~/hooks/useLoginUser'
import usePreventPageLeave from '~/libs/preventPageLeave'
import BillingEmailEditForm from '~/pages/Billing/components/BillingEmailEditForm'
import { useBillingEmails } from '~/pages/Billing/hooks/useBillingEmails'

export const BillingEdit: React.FC = () => {
  usePreventPageLeave()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const me = useLoginUser()
  const billingEmails = useBillingEmails(me.organizationId)
  const onEditSuccess = (): void => {
    toaster.create({
      title: t('pages.billing.message.billing_email_save_success'),
      type: 'success',
    })
    void navigate({
      to: `/billing`,
    })
  }
  const onCancel = (): void => {
    void navigate({
      to: `/billing`,
    })
  }

  return (
    <SideMenuLayoutContentLayout
      header={
        <Flex alignItems="center" justifyContent="space-between" width="full">
          <SideMenuLayoutBreadcrumb
            items={[
              {
                label: t('pages.billing.title'),
              },
              {
                label: t('pages.billing.label.edit'),
                bold: true,
              },
            ]}
          />
        </Flex>
      }
    >
      <BillingEmailEditForm
        billingEmails={billingEmails}
        onEditSuccess={onEditSuccess}
        onCancel={onCancel}
      />
    </SideMenuLayoutContentLayout>
  )
}
